var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChronoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 295.84 92.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#radial-gradient-2);}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 44.04,
    cy: 43.6,
    r: 19.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a6add"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8d31a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a097d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 21.75,
    cy: 21.49,
    r: 80.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a6add"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#973dad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a097d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 209.88,
    y1: 98.2,
    x2: 150,
    y2: -5.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a097d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a097d"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Chronox Logo 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.33,24.11a22.07,22.07,0,0,0-10.64,2.71H42A19.49,19.49,0,0,1,58.8,55H41.33A8.65,8.65,0,0,1,35,40.38h-9.4A16.78,16.78,0,0,0,41,63.08h14.9a21.56,21.56,0,0,0,2.62-2.7H41.33A14.07,14.07,0,0,1,27.63,43.1h2.8a11.37,11.37,0,0,0,10.9,14.57H60.4A22.2,22.2,0,0,0,41.33,24.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.62,65.78A19.48,19.48,0,0,1,23.85,37.67H41.33a8.64,8.64,0,0,1,6.29,14.56H57a16.78,16.78,0,0,0-15.69-22.7H26.78a22.26,22.26,0,0,0-2.62,2.7h3.1v0H41v0h.36A14.07,14.07,0,0,1,55,49.51h-2.8A11.36,11.36,0,0,0,41.33,35H22.25A22.2,22.2,0,0,0,52,65.8H40.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100,59.27a18.94,18.94,0,0,1-7.83,1.41c-8.36,0-14.63-5.28-14.63-15,0-9.31,6.28-15.56,15.49-15.56a16.23,16.23,0,0,1,7,1.3l-1,3.12a14.17,14.17,0,0,0-6-1.22c-7,0-11.57,4.45-11.57,12.24,0,7.25,4.18,11.89,11.36,11.89a15.66,15.66,0,0,0,6.29-1.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.58,29h3.85V42.26h.09a7.59,7.59,0,0,1,2.78-2.73,7.8,7.8,0,0,1,4-1.08c2.87,0,7.42,1.75,7.42,9.1V60.22h-3.86V48c0-3.44-1.29-6.32-4.92-6.32a5.63,5.63,0,0,0-5.22,3.86,5.27,5.27,0,0,0-.26,1.85V60.22h-3.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129,45.57c0-2.52-.06-4.66-.17-6.63h3.39l.15,4.17h.14a6.46,6.46,0,0,1,5.92-4.66,4.54,4.54,0,0,1,1.08.11V42.2a6.45,6.45,0,0,0-1.32-.11c-2.73,0-4.65,2.06-5.18,4.95a10.36,10.36,0,0,0-.15,1.81V60.22H129Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.21,49.38c0,7.88-5.47,11.32-10.58,11.32-5.77,0-10.23-4.2-10.23-11,0-7.12,4.68-11.29,10.57-11.29C158.09,38.45,162.21,42.89,162.21,49.38Zm-16.87.24c0,4.67,2.67,8.19,6.45,8.19s6.48-3.47,6.48-8.3c0-3.6-1.81-8.15-6.41-8.15S145.34,45.59,145.34,49.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.11,44.69c0-2.22-.08-4-.18-5.75h3.42l.21,3.5h.11a7.86,7.86,0,0,1,7-4c2.92,0,7.5,1.76,7.5,9.08V60.22h-3.85V48c0-3.44-1.3-6.32-4.92-6.32a5.58,5.58,0,0,0-5.22,4,6,6,0,0,0-.26,1.8V60.22h-3.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.79,49.38c0,7.88-5.47,11.32-10.58,11.32-5.78,0-10.23-4.2-10.23-11,0-7.12,4.68-11.29,10.56-11.29C206.66,38.45,210.79,42.89,210.79,49.38Zm-16.88.24c0,4.67,2.68,8.19,6.45,8.19s6.49-3.47,6.49-8.3c0-3.6-1.81-8.15-6.41-8.15S193.91,45.59,193.91,49.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.85,38.94l3.05,4.56c.8,1.19,1.46,2.27,2.17,3.46h.1c.71-1.25,1.41-2.35,2.15-3.5l3-4.52h4.21l-7.26,10.28,7.46,11h-4.38l-3.15-4.78c-.82-1.24-1.53-2.44-2.28-3.71h-.1c-.69,1.3-1.42,2.41-2.25,3.71l-3.06,4.78H212.2l7.57-10.86-7.23-10.42Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M249.69,50.9l-3.06,9.32h-4l10.09-29.66h4.61l10.13,29.66h-4.1L260.2,50.9Zm9.74-3-2.94-8.53c-.64-1.94-1.09-3.71-1.52-5.41h-.11c-.42,1.73-.88,3.54-1.47,5.36l-2.92,8.58Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M275.66,30.56V60.22h-3.85V30.56Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100,59.27a18.94,18.94,0,0,1-7.83,1.41c-8.36,0-14.63-5.28-14.63-15,0-9.31,6.28-15.56,15.49-15.56a16.23,16.23,0,0,1,7,1.3l-1,3.12a14.17,14.17,0,0,0-6-1.22c-7,0-11.57,4.45-11.57,12.24,0,7.25,4.18,11.89,11.36,11.89a15.66,15.66,0,0,0,6.29-1.21Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.58,29h3.85V42.26h.09a7.59,7.59,0,0,1,2.78-2.73,7.8,7.8,0,0,1,4-1.08c2.87,0,7.42,1.75,7.42,9.1V60.22h-3.86V48c0-3.44-1.29-6.32-4.92-6.32a5.63,5.63,0,0,0-5.22,3.86,5.27,5.27,0,0,0-.26,1.85V60.22h-3.85Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129,45.57c0-2.52-.06-4.66-.17-6.63h3.39l.15,4.17h.14a6.46,6.46,0,0,1,5.92-4.66,4.54,4.54,0,0,1,1.08.11V42.2a6.45,6.45,0,0,0-1.32-.11c-2.73,0-4.65,2.06-5.18,4.95a10.36,10.36,0,0,0-.15,1.81V60.22H129Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.21,49.38c0,7.88-5.47,11.32-10.58,11.32-5.77,0-10.23-4.2-10.23-11,0-7.12,4.68-11.29,10.57-11.29C158.09,38.45,162.21,42.89,162.21,49.38Zm-16.87.24c0,4.67,2.67,8.19,6.45,8.19s6.48-3.47,6.48-8.3c0-3.6-1.81-8.15-6.41-8.15S145.34,45.59,145.34,49.62Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.11,44.69c0-2.22-.08-4-.18-5.75h3.42l.21,3.5h.11a7.86,7.86,0,0,1,7-4c2.92,0,7.5,1.76,7.5,9.08V60.22h-3.85V48c0-3.44-1.3-6.32-4.92-6.32a5.58,5.58,0,0,0-5.22,4,6,6,0,0,0-.26,1.8V60.22h-3.85Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.79,49.38c0,7.88-5.47,11.32-10.58,11.32-5.78,0-10.23-4.2-10.23-11,0-7.12,4.68-11.29,10.56-11.29C206.66,38.45,210.79,42.89,210.79,49.38Zm-16.88.24c0,4.67,2.68,8.19,6.45,8.19s6.49-3.47,6.49-8.3c0-3.6-1.81-8.15-6.41-8.15S193.91,45.59,193.91,49.62Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.85,38.94l3.05,4.56c.8,1.19,1.46,2.27,2.17,3.46h.1c.71-1.25,1.41-2.35,2.15-3.5l3-4.52h4.21l-7.26,10.28,7.46,11h-4.38l-3.15-4.78c-.82-1.24-1.53-2.44-2.28-3.71h-.1c-.69,1.3-1.42,2.41-2.25,3.71l-3.06,4.78H212.2l7.57-10.86-7.23-10.42Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249.69,50.9l-3.06,9.32h-4l10.09-29.66h4.61l10.13,29.66h-4.1L260.2,50.9Zm9.74-3-2.94-8.53c-.64-1.94-1.09-3.71-1.52-5.41h-.11c-.42,1.73-.88,3.54-1.47,5.36l-2.92,8.58Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275.66,30.56V60.22h-3.85V30.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChronoxLogo);
export default __webpack_public_path__ + "static/media/New-Chronox-Logo.ad145b882b46f2da37d623aa217a92e4.svg";
export { ForwardRef as ReactComponent };